import { Box, Button, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import contractor from '../../../assets/contractor.png';
import { withFirebase } from '../../Firebase';

function UnstyledButtonCustom({ title, icon, onClick, ...props }) {
   const [iconUrl, setIconUrl] = useState(null);
   useEffect(() => {
      let cancelled = false;
      setIconUrl(null);

      if (icon && props.firebase) {
         if (icon === 'contractor') {
            setIconUrl(contractor);
         } else {
            const fullPath = props.firebase.showImage(icon);
            fullPath
               .getDownloadURL()
               .then((url) => {
                  if (!cancelled) setIconUrl(url);
               })
               .catch(() => {
                  if (!cancelled) setIconUrl(null);
               });
         }
      }

      return () => {
         cancelled = true;
      };
   }, [icon, props.firebase]);

   return (
      <Button
         variant="outlined"
         sx={{
            width: 300,
            height: 200,
            backgroundColor: '#fff',
            mt: 4,
            borderRadius: 2,
            '&:hover': { backgroundColor: '#f0f0f0' },
         }}
         onClick={onClick}
      >
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'column',
               alignContent: 'space-between',
            }}
         >
            {iconUrl !== null && (
               <Box>
                  <Box sx={{ mt: 1 }}>
                     <img
                        style={{
                           maxWidth: '100%',
                           maxHeight: '100px',
                           width: 'auto',
                           height: 'auto',
                        }}
                        src={iconUrl}
                     />
                  </Box>
                  <Divider sx={{ mt: 1, mb: 1 }} />
               </Box>
            )}
            <Box sx={{ fontSize: 'large' }}>{title}</Box>
         </Box>
      </Button>
   );
}

export default withFirebase(UnstyledButtonCustom);
